<template>
  <div class="portfolio_filter subtitle-fade" :class="{'showed': isShowFilter, 'top': top}">
    <div class="portfolio-filter_container" v-hotkey="keysmap">
      <p @click="toggleShowFilter">{{ title }}<span></span></p>
      <div class="portfolio_filter-items" v-show="isShowFilter">
        <p
          class="portfolio_filter-item fade_item"
          v-for='(item) in list'
          :key='item.type'
          @click="changeFilter(item)"
        ><span>{{ item.name }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: String,
    list_types: Array,
    dispatch: String,
    name: String,
    top: Boolean,
  },
  data() {
    return {
      isShowFilter: false,
      title: this.list_types.find(el => el.tp === this.active).name || this.list_types[0].name,
    };
  },
  methods: {
    toggleShowFilter() {
      this.isShowFilter = !this.isShowFilter;
      this.$emit('toggle-show-shadow', this.isShowFilter);
    },
    changeFilter(item) {
      this.toggleShowFilter();
      this.title = item.name;
      this.$store.dispatch(this.dispatch, item.tp);
    },
  },
  computed: {
    keysmap() {
      return {
        esc: () => {
          if (this.isShowFilter) {
            this.toggleShowFilter();
          }
        },
      };
    },
    list() {
      return this.list_types.filter(el => el.name !== this.title);
    },
  },
  watch: {
    list_types() {
      this.title = this.list_types[0].name;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/portfolio/Filter.vue